import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const alert = {
  success,
  error,
  info,
  clear,
};

function success(message) {
  toast.success(message);
}

function error(message) {
  toast.error(message);
}

// For things the customer should notice but that are not failures, such as a
// price update we have already applied to their basket.
function info(message) {
  toast.info(message);
}

function clear() {
  // toast.dismiss();
}
